import { defineStore } from 'pinia'
import { client as api } from '@clevver/api/clevver_client'
import {
  User,
} from '@clevver/types'

interface UserState {
  user: User | null,
 }

const initialState: UserState = {
  user: null,
 }

export const useUserStore = defineStore('user.store', {
  state: (): UserState => ({ ...initialState }),
  getters: {},
  actions: {
    async fetchUser() {
      const { data } = await api.getUser()
      this.user = data as User
    }
  }
})